import { resolveCommunicationChartNodeHoverScale, resolveCommunicationChartOverlayOpacity } from '@web/components/CommunicationNetworkGraph/graph/communicationChartMotion';
import { drawCommunicationChartNodeCircle, resolveCommunicationChartCanvasNodeLabel, resolveCommunicationChartNodeLabelFontSizePx, resolveCommunicationChartNodeVisual } from '@web/components/CommunicationNetworkGraph/graph/drawCommunicationChartNodeCircle';
var CANVAS_HUB_NODE_SELECTOR = '.external, .crossTeamAggregate, .internalMeet, .crossTeamSpaceChat, .externalSpaceChat, .other';
var drawCanvasHubNode = function (ctx, node, opacity) {
    var position = node.renderedPosition();
    var renderedSize = node.renderedWidth();
    if (!Number.isFinite(renderedSize) || renderedSize <= 0) {
        return;
    }
    var size = renderedSize * resolveCommunicationChartNodeHoverScale(node);
    var radius = size / 2;
    var visual = resolveCommunicationChartNodeVisual(node);
    var label = resolveCommunicationChartCanvasNodeLabel(node);
    drawCommunicationChartNodeCircle({
        ctx: ctx,
        x: position.x,
        y: position.y,
        radius: radius,
        visual: visual,
        opacity: opacity,
        label: label,
        labelFontSizePx: label
            ? resolveCommunicationChartNodeLabelFontSizePx(node, size)
            : undefined
    });
};
export var drawCommunicationChartHubNodeOverlay = function (cy, ctx) {
    cy.nodes(CANVAS_HUB_NODE_SELECTOR).forEach(function (node) {
        if (node.hasClass('hubHidden')) {
            return;
        }
        drawCanvasHubNode(ctx, node, resolveCommunicationChartOverlayOpacity(node));
    });
};
